import React from "react";
import "./SearchPopularKeyword.scss";
import { usePopularKeywords } from "../../../query/usePopularKeywords";
import dayjs from "dayjs";
import PropTypes from "prop-types";

/**
 * 인기 검색어
 * @returns {Element}
 * @constructor
 */
export default function SearchPopularKeyword({ handleOnQueryClick }) {
  const { loading, data, error } = usePopularKeywords();

  let keywords = [];
  if (
    !loading &&
    !error &&
    data &&
    data.getPopularKeywordsByFilterCached &&
    data.getPopularKeywordsByFilterCached.popularKeywords
  ) {
    keywords = data.getPopularKeywordsByFilterCached.popularKeywords.slice(
      0,
      10,
    );
  }
  while (keywords.length < 10) keywords.push("");
  const left = keywords.slice(0, 5);
  const right = keywords.slice(5, 10);

  const now = new Date();
  const hour = dayjs(now).hour();

  return (
    <div className="SearchPopularKeyword">
      <div className="SearchPopularKeyword-header">
        <span className="SearchPopularKeyword-title">인기 검색어</span>
        <span className="SearchPopularKeyword-time">{`오늘 ${hour}시 기준`}</span>
      </div>
      {loading ? (
        <div className="SearchPopularKeyword-loading">로딩중...</div>
      ) : (
        <div className="SearchPopularKeyword-list-wrap">
          <ol className="SearchPopularKeyword-list">
            {left.map((item, i) => (
              <li
                key={i}
                className="SearchPopularKeyword-item"
                onClick={() => handleOnQueryClick(item.text)}
              >
                <span className="SearchPopularKeyword-rank">{i + 1}</span>
                <span className="SearchPopularKeyword-keyword">
                  {item.text}
                </span>
              </li>
            ))}
          </ol>
          <ol className="SearchPopularKeyword-list">
            {right.map((item, i) => (
              <li
                key={i + 5}
                className="SearchPopularKeyword-item"
                onClick={() => handleOnQueryClick(item.text)}
              >
                <span className="SearchPopularKeyword-rank">{i + 6}</span>
                <span className="SearchPopularKeyword-keyword">
                  {item.text}
                </span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}

SearchPopularKeyword.propTypes = {
  handleOnQueryClick: PropTypes.func,
};
